module.exports = __webpack_public_path__ + "static/media/StarLord.ab1b9508.png";